import { PropertyExpenseDTO } from "../DTO/propertyExpenseDTO";

export class PropertyExpense{
    public id?:number;
    public propertyId!:number;
    public description!:string;
    public amount!:number;
    public userId?:string;
    public userName?:string;
    public userFirstName?:string;
    public userLastName?:string;
    public added?:Date;
    public edited?:Date;

    public static mapToDTO(param:PropertyExpense) : PropertyExpenseDTO{
        
        let dto = new PropertyExpenseDTO();
        try
        {
            dto.id = param.id;
            dto.propertyId = param.propertyId;
            dto.description = param.description;
            dto.amount = param.amount;
            dto.userId = param.userId;
            dto.userName = param.userName;
            dto.userFirstName = param.userFirstName;
            dto. userLastName = param.userLastName;
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.edited = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertyExpenseDTO) : PropertyExpense
    {
        
        let obj = new PropertyExpense();
        try
        {
            obj.id = param.id;
            obj.propertyId = param.propertyId;
            obj.description = param.description;
            obj.amount = param.amount;
            obj.userId = param.userId;
            obj.userName = param.userName;
            obj.userFirstName = param.userFirstName;
            obj. userLastName = param.userLastName;
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    get userFullName(){
        return this.userFirstName + ' ' + this.userLastName;
    }
}